export function isNotEmpty(value) {
  return Object.keys(value).length > 0
}
